import { z, type ZodTypeAny } from 'zod'
import { FieldState } from '@/shared/constants'

export function schemaForFieldWithState<TType extends ZodTypeAny>(value: TType) {
  return z.object({
    value,
    state: z.nativeEnum(FieldState).nullable(),
    reason: z.string().nullable(),
  })
}
